export const getMinutesAsMilliseconds = (minutes: number): number => minutes * 60 * 1000;
